export default __webpack_public_path__ + "7dff1ba566d4f077d284729d0f0d2580.svg";